import { Dispatch } from "redux";
import { TaskComment } from "../../types/TaskComment";
import {
  getTaskComments,
  getTaskCommentById,
  createTaskComment,
  updateTaskComment,
  deleteTaskComment,
} from "../../services/TaskCommentService";

export enum TaskCommentActionList {
  ADD_TASK_COMMENT = "ADD_TASK_COMMENT",
  EDIT_TASK_COMMENT = "EDIT_TASK_COMMENT",
  FETCH_TASK_COMMENTS = "FETCH_TASK_COMMENTS",
  DELETE_TASK_COMMENT = "DELETE_TASK_COMMENT",
  FETCH_TASK_COMMENT_BY_ID = "FETCH_TASK_COMMENT_BY_ID",
}

export interface AddTaskCommentAction {
  type: TaskCommentActionList.ADD_TASK_COMMENT;
  data: TaskComment;
}

export interface EditTaskCommentAction {
  type: TaskCommentActionList.EDIT_TASK_COMMENT;
  data: TaskComment;
  id: number;
}
export interface FetchCommentByIdAction {
  type: TaskCommentActionList.FETCH_TASK_COMMENT_BY_ID;
  data: TaskComment | null;
}
export interface FetchTaskCommentsAction {
  type: TaskCommentActionList.FETCH_TASK_COMMENTS;
  data: TaskComment[];
}

export interface DeleteTaskCommentAction {
  type: TaskCommentActionList.DELETE_TASK_COMMENT;
  data: number;
}

export type TaskCommentActions =
  | AddTaskCommentAction
  | EditTaskCommentAction
  | FetchTaskCommentsAction
  | DeleteTaskCommentAction;

export const fetchTaskCommentsAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getTaskComments();
    dispatch<FetchTaskCommentsAction>({
      type: TaskCommentActionList.FETCH_TASK_COMMENTS,
      data: response,
    });
  };
};
export const fetchTaskCommentByIdAction = (id: string) => {
  return async (dispatch: Dispatch) => {
    try {
      const rawData = await getTaskCommentById(id);
      dispatch<FetchCommentByIdAction>({
        type: TaskCommentActionList.FETCH_TASK_COMMENT_BY_ID,
        data: rawData.data,
      });
    } catch (error: any) {
      console.error("Failed to fetch Comment by ID", error);
      dispatch<FetchCommentByIdAction>({
        type: TaskCommentActionList.FETCH_TASK_COMMENT_BY_ID,
        data: null,
      });
    }
  };
};
export const addTaskCommentAction = (data: TaskComment) => {
  return async (dispatch: Dispatch) => {
    const response = await createTaskComment(data);
    dispatch<AddTaskCommentAction>({
      type: TaskCommentActionList.ADD_TASK_COMMENT,
      data: response.data.data,
    });
  };
};

export const editTaskCommentAction = (id: number, data: TaskComment) => {
  return async (dispatch: Dispatch) => {
    const response = await updateTaskComment(id, data);
    dispatch<EditTaskCommentAction>({
      type: TaskCommentActionList.EDIT_TASK_COMMENT,
      data: response.data.data,
      id,
    });
  };
};

export const deleteTaskCommentAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    await deleteTaskComment(id);
    dispatch<DeleteTaskCommentAction>({
      type: TaskCommentActionList.DELETE_TASK_COMMENT,
      data: id,
    });
  };
};
